import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import { getData, getFirst, isValid } from 'clients/Clients';
import { getUserLogGuide } from 'clients/CustomerClient';
import { postVoucherList } from 'clients/PromoClient';
import clsx from 'clsx';
import AnotherSeller from 'components-v2/mocules/AnotherSeller';
import BuyWithDeal from 'components-v2/mocules/BuyWithDeal';
import ComboList from 'components-v2/mocules/ComboList';
import SuggestProductBlock from 'components-v2/mocules/SuggestProductBlock';
import FlagshipLabel from 'components-v2/mocules/FlagshipLabel';
import HotInfo from 'components-v2/mocules/HotInfo';
import IconButtonCustom from 'components-v2/mocules/IconButtonCustom';
import ModalTour from 'components-v2/mocules/ModalTour';
import OtherInfoSeller from 'components-v2/mocules/OtherInfoSeller';
import PriceAfterDiscount from 'components-v2/mocules/PriceAfterDiscount';
import PromotionPC from 'components-v2/mocules/PromotionProduct/PromotionPC';
import PromoType from 'components-v2/mocules/PromoType';
import TagGiftComp from 'components-v2/mocules/TagGiftComp';
import TourIntro from 'components-v2/mocules/TourIntro';
import LeftContent from 'components-v2/organisms/pages/detail-product-new/LeftContent';
import ProductDetailPrices from 'components-v2/organisms/ProductDetailPrices';
import { QuestionAndAnswer } from 'components-v2/organisms/QuestionAndAnswer';
import Breadcrumbs from 'components/mocules/Breadcrumbs';
import FeedbackPriceFormModal from 'components/mocules/FeedbackPriceFormModal';
import ProductDetailAlertPriceAfterApplyVoucher from 'components/mocules/ProductDetailAlertPriceAfterApplyVoucher';
import PromotionDetailModal from 'components/mocules/PromotionDetailModal';
import SlideCoupon from 'components/mocules/SlideCoupon';
import TagComponent from 'components/mocules/TagComponent';
import { VoucherCollectListSkeleton } from 'components/organisms/ProductDetailLoading';
import { GUIDE_FEATURE } from 'constants/data/guideline';
import { BRAND_NAME, LEVEL_CUSTOMER } from 'constants/Enums';
import { MISSING_IMAGE, PRODUCT_DETAIL_VOUCHER_ICON_PATH } from 'constants/Images';
import { SVGPrice } from 'constants/SVG';
import { EnumBlockCodeTracking } from 'constants/tracking';
import { useCart } from 'context/Cart/CartContext';
import { useSetting } from 'context/Settings';
import { useTicket } from 'context/Ticket';
import { useCategories } from 'hooks/useCategories';
import { useConfigHangDiem } from 'hooks/useConfigHangDiem';
import { useManufacturers } from 'hooks/useManufacturers';
import useModal from 'hooks/useModal';
import Image from 'next/image';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import { getMedicineTypeLabels } from 'utils/ProductLabelUtils';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getSKUErrorMessage } from 'services/convertNewAPIProduct';
import { getMeGuide, updateMeGuide } from 'services/CustomerService';
import { getSortedProducts, moveKcbPriorityFirst } from 'services/ProductService';
import { isKcbVerifiedUser } from 'hooks/useIsKcbVerified';
import ProductServiceV2 from 'services/ProductServiceV2';
import { getSellerData } from 'services/SellerService';
import { DISLIKE_FEEDBACK_CODE, LIKE_FEEDBACK_CODE } from 'sysconfig';
import { formatCurrency } from 'utils/FormatNumber';
import { isEqual } from 'utils/helper';
import { useStore } from 'zustand-lib/storeGlobal';
import useCategoryFilterTree from 'zustand-lib/useCategoryFilterTree';
import ModalViewMore from '../ModalViewMore';
import ReplaceProduct, { TourSubstituteSKU } from '../ReplaceProduct';
import ProductsRecommendation from './ProductsRecommendation';
import ProductsSameIngredient from './ProductsSameIngredient';
import ProductsSameSeller from './ProductsSameSeller';
import { SectionInformation } from './SectionInformation/SectionInformation';
import { SectionRetailPrice } from './SectionRetailPrice/SectionRetailPrice';
import styles from './styles.module.css';

const DEFAULT_STEPS = ['infoProduct', 'addToCart'];
const SellerTypeNoViewMore = ['INDIVIDUAL', 'MARKET'];
const KEY = 'PRODUCT_DETAIL_DISPLAY_PRICE_AFTER_DISCOUNT';

const MoneyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.27273 5.81818H10.1818C10.3747 5.81818 10.5597 5.74156 10.6961 5.60517C10.8325 5.46878 10.9091 5.28379 10.9091 5.09091C10.9091 4.89802 10.8325 4.71304 10.6961 4.57665C10.5597 4.44026 10.3747 4.36364 10.1818 4.36364H8.72727V3.63636C8.72727 3.44348 8.65065 3.25849 8.51426 3.1221C8.37787 2.98571 8.19289 2.90909 8 2.90909C7.80712 2.90909 7.62213 2.98571 7.48574 3.1221C7.34935 3.25849 7.27273 3.44348 7.27273 3.63636V4.36364C6.69408 4.36364 6.13912 4.59351 5.72995 5.00268C5.32078 5.41185 5.09091 5.9668 5.09091 6.54545C5.09091 7.12411 5.32078 7.67906 5.72995 8.08823C6.13912 8.4974 6.69408 8.72727 7.27273 8.72727H8.72727C8.92016 8.72727 9.10514 8.80389 9.24153 8.94028C9.37792 9.07668 9.45455 9.26166 9.45455 9.45454C9.45455 9.64743 9.37792 9.83241 9.24153 9.9688C9.10514 10.1052 8.92016 10.1818 8.72727 10.1818H5.81818C5.6253 10.1818 5.44032 10.2584 5.30393 10.3948C5.16754 10.5312 5.09091 10.7162 5.09091 10.9091C5.09091 11.102 5.16754 11.287 5.30393 11.4233C5.44032 11.5597 5.6253 11.6364 5.81818 11.6364H7.27273V12.3636C7.27273 12.5565 7.34935 12.7415 7.48574 12.8779C7.62213 13.0143 7.80712 13.0909 8 13.0909C8.19289 13.0909 8.37787 13.0143 8.51426 12.8779C8.65065 12.7415 8.72727 12.5565 8.72727 12.3636V11.6364C9.30593 11.6364 9.86088 11.4065 10.2701 10.9973C10.6792 10.5882 10.9091 10.0332 10.9091 9.45454C10.9091 8.87589 10.6792 8.32094 10.2701 7.91177C9.86088 7.5026 9.30593 7.27273 8.72727 7.27273H7.27273C7.07984 7.27273 6.89486 7.1961 6.75847 7.05971C6.62208 6.92332 6.54546 6.73834 6.54546 6.54545C6.54546 6.35257 6.62208 6.16758 6.75847 6.03119C6.89486 5.8948 7.07984 5.81818 7.27273 5.81818ZM8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.0034663 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 14.5455C6.70543 14.5455 5.43994 14.1616 4.36354 13.4423C3.28715 12.7231 2.4482 11.7009 1.95279 10.5048C1.45738 9.30881 1.32776 7.99274 1.58032 6.72304C1.83288 5.45335 2.45627 4.28706 3.37167 3.37166C4.28707 2.45627 5.45335 1.83287 6.72305 1.58031C7.99274 1.32776 9.30881 1.45738 10.5048 1.95279C11.7009 2.4482 12.7231 3.28715 13.4423 4.36354C14.1616 5.43993 14.5455 6.70543 14.5455 8C14.5455 9.73596 13.8558 11.4008 12.6283 12.6283C11.4008 13.8558 9.73596 14.5455 8 14.5455Z"
      fill="#8C8C8C"
    />
  </svg>
);

export default function DetailProductPcScreenNew({ product, orderedCount, sellerInfo, user, seller, link, tags }) {
  const isKcbVerified = isKcbVerifiedUser(user);
  const {
    name,
    imagesProxy,
    limitPerDay,
    displayPriceFormated,
    salePriceFormated,
    discountPercent,
    productType,
    campaign,
    messageLimitOrder,
    manufacturerCode,
    volume,
    sku,
    productId,
    nextPrice,
    nextLevel,
    vouchers,
    deal,
    sellerCode = '',
    doseUnitName,
    retailPricePerUnit,
    vendorInfo,
    discountPriceInfo,
    originPrice,
    highProfitRetailValue,
    highProfitRetailPrice,
    videoUrls = [],
  } = product;

  // Nhãn phân loại thuốc (kê đơn / không kê đơn / thiết yếu / kiểm soát đặc biệt)
  const medicineTypeLabels = getMedicineTypeLabels(product);

  const stepState = JSON.parse(localStorage.getItem('stepProductDetail'));
  const refOne = useRef();
  const refTwo = useRef();
  const refThree = useRef();
  const refFour = useRef();
  const { mapDataProduct } = useCart();
  const [defaultSteps, setDefaultSteps] = useState(DEFAULT_STEPS);
  const [productDeals, setProductDeals] = useState([]);
  const [productReplace, setProductReplace] = useState();
  const [isShowViewMore, setIsShowViewMore] = useState(false);
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [productsSame, setProductsSame] = useState([]);
  const [infoGift, setInfoGift] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const { sendLikeFeedback, isSkuFeedbackedPrice } = useTicket();
  const feedback = isSkuFeedbackedPrice({ sku });
  const [isShowModalHighPrice, toggleModalHighPrice] = useModal();
  const [loading, setLoading] = useState({
    recommendations: false,
    sameProduct: false,
    productDeals: false,
    productBySeller: false,
    sameIngredient: false,
    voucherCollectList: false,
  });
  const [listVoucherProduct, setListVoucherProduct] = useState([]);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const router = useRouter();
  const { slug } = router.query;
  const { getCategoryMapByCode } = useCategories();
  const { categoryFilterTree, fetchCategoryFilterTree } = useCategoryFilterTree();

  const { getTopManufacturers } = useManufacturers();
  const { configs } = useSetting();

  // Fetch categoryFilterTree on mount (will be cached)
  useEffect(() => {
    fetchCategoryFilterTree();
  }, [fetchCategoryFilterTree]);

  let tabs = useStore((state) => state.tabs);

  // Build breadcrumbs from URL query params (same logic as ProductListing)
  useEffect(() => {
    (async () => {
      const defaultBreadcrumbs = [{ name: 'Trang chủ', url: '/' }];

      if (Object.keys(router.query).length > 0) {
        const { query } = router;

        if (query.currentTab) {
          const tabName = tabs?.filter((item) => item.slug === query.currentTab) || [];
          const tabNameValue = tabName?.length > 0 ? tabName[0]?.name : null;
          if (tabNameValue) {
            const item = { name: tabNameValue, url: `/products?currentTab=${query.currentTab}` };
            defaultBreadcrumbs.push(item);
          }
        }

        // Lấy raw URL
        const queryString = router.asPath.split('?')[1];

        const params = new URLSearchParams(queryString);
        const querySlug = params.get('slug');

        // Determine base path: if querySlug exists, use manufacturer path, otherwise use /products
        const basePath = querySlug ? `/manufacturers/${querySlug}` : '/products';

        if (querySlug) {
          const topManufacturers = await getTopManufacturers();
          const manufacture = topManufacturers.find((item) => item.slug === querySlug);

          if (manufacture) {
            const item = {
              name: manufacture?.shortName,
              url: `${basePath}?${query.tag ? `&tag=${query.tag}` : ''}${query.currentTab ? `&currentTab=${query.currentTab}` : ''}`,
            };
            defaultBreadcrumbs.push(item);
          }
        }

        // Handle tag breadcrumb (submenu item)
        if (query.tag) {
          const categoryFromTree = categoryFilterTree?.find((item) => item?.mapParams?.tag === query.tag);
          if (categoryFromTree?.label) {
            defaultBreadcrumbs.push({ name: categoryFromTree.label, url: `${basePath}?tag=${query.tag}` });
          }
        } else {
          // Only push "Sản phẩm" if basePath is /products (not manufacturer)
          if (!querySlug) {
            defaultBreadcrumbs.push({ name: 'Sản phẩm', url: basePath });
          }
        }

        // Handle category and efficacy breadcrumbs from filter param
        if (query.filter) {
          let categoryFilters = [];
          try {
            categoryFilters = JSON.parse(query.filter || '{}').categoryFilters || [];
          } catch (e) {
            categoryFilters = [];
          }

          const normalCategory = categoryFilters.filter((item) => !item.isCombined);
          const combinedCategory = categoryFilters.filter((item) => item.isCombined);

          const mapCategories = await getCategoryMapByCode();

          // Get category names from categoryCodes
          const categoryNames = normalCategory
            ?.filter((item) => !item.isCombined)
            ?.reduce((acc, category) => {
              const codes = category.categoryCodes || [];
              const names = codes.map((code) => mapCategories.get(code)?.name).filter(Boolean);
              return [...acc, ...names];
            }, [])
            ?.sort((a, b) => a.localeCompare(b))
            ?.join(' | ');

          const newCategoryFilters = categoryFilters
            ?.filter((item) => !item.isCombined)
            ?.map((cat) => ({
              ...cat,
              efficacyCodes: [],
            }));

          if (categoryNames) {
            const categoryUrl = `${basePath}?filter=${JSON.stringify({ categoryFilters: newCategoryFilters })}${query.tag ? `&tag=${query.tag}` : ''}${query.currentTab ? `&currentTab=${query.currentTab}` : ''}`;
            defaultBreadcrumbs.push({
              name: categoryNames,
              url: categoryUrl,
            });
          }

          const efficacyMap = {};
          mapCategories.forEach((value) =>
            value.subEfficacies?.forEach((subEff) => {
              efficacyMap[subEff.code] = subEff;
            }),
          );

          const normalEfficacyNames = normalCategory
            ?.filter((item) => !item.isCombined)
            ?.reduce((acc, c) => [...acc, ...(c?.efficacyCodes || [])], [])
            ?.map((code) => efficacyMap[code]?.name);

          const combinedEfficacyNames = combinedCategory?.map((item) => efficacyMap[item.code]?.name);

          const efficacyNames = [...normalEfficacyNames, ...combinedEfficacyNames]?.sort((a, b) => a.localeCompare(b))?.join(' | ');

          if (efficacyNames) {
            const efficacyUrl = `${basePath}?filter=${query.filter}${query.currentTab ? `&currentTab=${query.currentTab}` : ''}${query.tag ? `&tag=${query.tag}` : ''}`;
            defaultBreadcrumbs.push({ name: efficacyNames, url: efficacyUrl });
          }
        }
      }

      // Add product name as last breadcrumb
      if (product?.name) {
        defaultBreadcrumbs.push({
          name: product.name,
          url: router.asPath,
        });
      }

      setBreadcrumbs(defaultBreadcrumbs);
    })();
  }, [product?.name, router.asPath, router.query, getCategoryMapByCode, categoryFilterTree, tabs]);

  const appSetting = useStore((state) => state.appSetting);
  const flexibleWarning = appSetting[KEY];
  const errorMessageProduct = getSKUErrorMessage(product, appSetting);
  const combineImageAndVideo = useMemo(() => {
    return [...videoUrls, ...imagesProxy] || [];
  }, [imagesProxy, videoUrls]);
  const { isHangDiem, config: configHangDiem, iconHangDiem, linkRedirect } = useConfigHangDiem({ vendorInfoSellerCode: vendorInfo?.sellerCode });

  const condDisplayPriceAfterApplyVoucher = () => {
    const conditionProvince = user?.provinceCode ? flexibleWarning?.provinceCodesApplyFormula?.includes(user?.provinceCode) : false;
    const conditionSku = product?.sku ? flexibleWarning?.skipSkus?.includes(product.sku) : false;

    return conditionProvince && !conditionSku && flexibleWarning?.isActive;
  };

  const {
    sellerName,
    isDisplayStore,
    linkStore,
    linkSeller,
    avatar = [],
    isStore = false,
    isInternal,
    individualNonVatSellerName = '',
    fullNameSeller,
  } = getSellerData({ seller: product.sellerInfo, tags });
  const isOnlyDiscountWithoutValue = useMemo(() => {
    return discountPriceInfo?.map((item) => item?.discount)?.every((item) => item === 0 || !item) ?? false;
  }, [discountPriceInfo]);

  const handleLogical = () => {
    sendLikeFeedback({ sku, productId });
  };

  function turnOnScrollBody() {
    document.body.style.overflow = 'auto';
    document.body.style.paddingRight = '0px';
  }

  useEffect(() => {
    if (vouchers) {
      const newInfoGift = vouchers
        .map((item) => item?.gifts)
        .filter((gifts) => gifts)
        .flat();
      setInfoGift(newInfoGift);
    }
  }, [vouchers]);

  const funcRevertListProductDetail = (productDeal) => {
    return productDeal
      .filter((x) => x?.status !== 'OUT_OF_STOCK')
      ?.map((productInCombo) => {
        if (productInCombo?.skus?.length === 1) {
          const retalPriceIndividualProduct = productInCombo?.displayPrice / productInCombo?.skus?.[0]?.quantity;
          const retalPriceDifferencePrice = Math.ceil(product.displayPrice - retalPriceIndividualProduct);
          if (retalPriceDifferencePrice > 0) {
            // eslint-disable-next-line no-param-reassign
            productInCombo.retalPriceDifferencePrice = formatCurrency(retalPriceDifferencePrice);
          }
        }
        return productInCombo;
      });
  };

  const conditionIsSame = (stepsShallow) => isEqual(stepState?.stepsFinish, stepsShallow) && stepsShallow?.length === stepState?.stepsFinish?.length;

  const [showSubstituteGuide, setShowSubstituteGuide] = useState(false);

  async function handleShowSusbstituteGuide() {
    const respCheckGuide = await getUserLogGuide({
      q: {
        feature: GUIDE_FEATURE.SUBSTITUTE_SKU_OTHERS,
      },
    });

    if (respCheckGuide.status === 'OK') {
      const dataCheckGuide = getFirst(respCheckGuide);
      if (dataCheckGuide?.isActive && !dataCheckGuide?.isGuided) {
        setShowSubstituteGuide(true);
      }
    }
  }

  async function handleShowGuide(stepsShallow) {
    const meGuide = await getMeGuide(GUIDE_FEATURE.PRODUCT_DETAIL);
    if (meGuide.isActive && !meGuide.isGuided) {
      const isSame = conditionIsSame(stepsShallow);
      if (stepState?.stepsFinish?.length > stepsShallow?.length) {
        const isSameStep = stepsShallow.some((x) => stepState?.stepsFinish?.includes(x));
        if (isSameStep) {
          setOpen(false);
          handleShowSusbstituteGuide();
          return;
        }
      } else if (!stepState?.isFinish && !isSame) {
        setOpen(true);
        return;
      }
    }
    handleShowSusbstituteGuide();
  }

  const fetchData = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        recommendations: true,
        sameProduct: true,
        productDeals: true,
      }));
      const [sameProduct, productDeals] = await Promise.all([
        ProductServiceV2.getSearchSameProduct({ productCode: product?.skuId }),
        !product?.isCombo && ProductServiceV2.getComboContainingProduct({ skuCode: product?.sku }),
      ]);
      setLoading((prevLoading) => ({
        ...prevLoading,
        recommendations: false,
        sameProduct: false,
        productDeals: false,
      }));

      const stepsShallow = [...defaultSteps];
      if (!product?.isCombo) {
        const productDeal = mapDataProduct(getData(productDeals)?.filter((item) => item.isAvailable));
        const revertListProductDeal = moveKcbPriorityFirst(funcRevertListProductDetail(productDeal), isKcbVerified);
        if (revertListProductDeal.length > 0) {
          setDefaultSteps((steps) => [...steps, 'productsDeal']);
          stepsShallow.push('productsDeal');
        }

        const productDealsWithTracking = revertListProductDeal.map((item) => ({
          ...item,
          blockCode: EnumBlockCodeTracking.PRODUCT_DETAIL_COMBO_SUGGESTION,
        }));

        setProductDeals(productDealsWithTracking);
      }

      if (sameProduct && isValid(sameProduct)) {
        const listProductSame = getSortedProducts(
          getData(sameProduct)
            ?.filter((item) => item?.sku !== product?.sku)
            ?.map((prd) => ({ ...prd, isSameProduct: true })) || [],
        );

        const revertListProductSame = moveKcbPriorityFirst(
          listProductSame.filter((x) => x?.status !== 'OUT_OF_STOCK')?.sort((a, b) => a?.displayPrice - b?.displayPrice),
          isKcbVerified,
        );
        if (revertListProductSame.length > 0) {
          setDefaultSteps((steps) => [...steps, 'productsSame']);
          stepsShallow.push('productsSame');
        }

        const productSameWithTracking = revertListProductSame.map((item) => ({
          ...item,
          blockCode: EnumBlockCodeTracking.PRODUCT_DETAIL_SAME_PRODUCT_ID,
        }));

        setProductsSame(productSameWithTracking);
        setLoading((prevLoading) => ({ ...prevLoading, sameIngredient: false }));
      }

      await handleShowGuide(stepsShallow);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading({
        recommendations: false,
        sameProduct: false,
        productDeals: false,
        productBySeller: false,
        sameIngredient: false,
        voucherCollectList: false,
      });
    }
  };

  const fetchCollectionVoucher = async () => {
    setLoading({
      ...loading,
      voucherCollectList: true,
    });

    const querySellerPromos = {
      ctx: '',
      accountID: user?.accountId,
      scope: 'seller',
      sellerCode,
      getVoucherToCollect: true,
      skipVoucherCollected: false,
      storeCode: '',
      getMedxVoucherOnly: false,
    };

    if (sellerCode === 'MEDX' && vendorInfo?.storeType === 'FLAGSHIP') {
      querySellerPromos.sellerCode = '';
      querySellerPromos.storeCode = vendorInfo.code;
    } else if (sellerCode === 'MEDX') {
      querySellerPromos.getMedxVoucherOnly = true;
    }

    const [respMarketplacePromos, respSellerPromos] = await Promise.all([
      postVoucherList({
        ctx: '',
        accountID: user?.accountId,
        scope: 'marketplace',
        sellerCode,
        getVoucherToCollect: true,
        skipVoucherCollected: false,
      }),
      postVoucherList(querySellerPromos),
    ]);

    const vouchersList = [];

    // handle resp voucher collect list
    if (isValid(respSellerPromos)) {
      vouchersList.push(...getData(respSellerPromos));
    }

    if (isValid(respMarketplacePromos)) {
      vouchersList.push(...getData(respMarketplacePromos));
    }

    setListVoucherProduct(vouchersList);

    setLoading({
      ...loading,
      voucherCollectList: false,
    });
  };

  // Attach a popstate event listener
  const handlePopstate = () => {
    // Reload the page
    window.location.reload();
  };

  useEffect(() => {
    fetchData();
    fetchCollectionVoucher();

    window.addEventListener('popstate', handlePopstate);
    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, [product?.slug]);

  useEffect(() => {
    if (product.skuReplace?.length) {
      setIsShowViewMore(product.skuReplace.length > 1);
      // seller lấy từ DTO lite (BFF đã dựng tên/link như card SP mua kèm)
      const { sellerName, sellerUrl } = product.skuReplaceLite?.[0] || {};
      setProductReplace({ ...ProductServiceV2.convertProductV2(product.skuReplace[0]), sellerName, sellerUrl });
    }
  }, []);

  const toggleOpenModal = () => {
    setOpenModal((isOpen) => !isOpen);
  };

  const closeModal = () => {
    setOpenModal(false);
    turnOnScrollBody();
  };

  const handleOpen = () => {
    setShowGiftModal(true);
  };

  const date = new Date(campaign?.campaign.startTime);
  const monthYear = `${date.getMonth() + 1}/${date.getFullYear()}`;

  function handleClose() {
    setOpen(false);
    handleShowSusbstituteGuide();
    updateMeGuide({ feature: GUIDE_FEATURE.PRODUCT_DETAIL, isViewAll: true });

    // Trick: push this line code to task queue to make sure this code works
    requestIdleCallback(() => {
      turnOnScrollBody();
    });
  }

  function onFinish(hasViewedAllSteps) {
    turnOnScrollBody();
    setIsReady(false);
    handleShowSusbstituteGuide();
    hasViewedAllSteps && updateMeGuide({ feature: GUIDE_FEATURE.PRODUCT_DETAIL });
  }

  function handleConfirmModal() {
    setIsReady(true);
    setOpen(false);
  }

  const conditionRenderTitle = (type) => {
    return type ? `Bạn đã phản hồi cho ${BRAND_NAME} trong tuần này` : 'Giá hợp lý';
  };
  const conditionRenderTitleFb = (type) => {
    return type ? `Bạn đã phản hồi cho ${BRAND_NAME} trong tuần này` : 'Giá cao';
  };
  const conditionRenderNextLevel = () => {
    return nextPrice > 0 && product?.status !== 'OUT_OF_STOCK';
  };
  const conditionRenderIntroduce = () => {
    return seller?.code && sellerName && (product?.sellerInfo?.description || product?.vendorInfo?.description);
  };
  const conditionRenderIntroduceHardCode = () => {
    return product?.vendorInfo && Object.keys(product.vendorInfo).length > 0 && seller?.code && sellerName;
  };

  return (
    <div className={clsx(styles.wrapperContainer, openModal && styles.showModal)}>
      <Container disableGutters style={{ maxWidth: '1180px' }}>
        {breadcrumbs.length > 0 && (
          <div style={{ marginBottom: '10px' }}>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          </div>
        )}
        <Grid container spacing={3} className={styles.wrapper}>
          <Grid item xs={4} ref={refOne}>
            <div className={styles.bigImage}>
              <LeftContent
                product={product}
                imagesProxy={combineImageAndVideo?.length === 0 ? [MISSING_IMAGE] : combineImageAndVideo}
                orderedCount={orderedCount}
                user={user}
                limitPerDay={limitPerDay}
                messageLimitOrder={messageLimitOrder}
              />
            </div>
          </Grid>

          <Grid item className={styles.rightGrid} xs={8}>
            {productType !== 'NORMAL' ? (
              <HotInfo
                title={<PromoType productType={campaign?.campaign} monthYear={monthYear} />}
                productType={productType}
                campaign={campaign}
                deal={deal}
              />
            ) : null}
            <div>
              <Typography className={styles.typographyTitle} variant="h1">
                <FlagshipLabel
                  isVip={sellerInfo?.isVip}
                  isStore={sellerInfo?.isStore}
                  productTags={product?.tags}
                  isHangDiem={isHangDiem}
                  hangdiemConfig={configHangDiem || {}}
                />
                {product?.isTagGift && <TagGiftComp />} {name || ''}
              </Typography>
              <Typography className={styles.typographyRight}> {volume || ''}</Typography>
            </div>

            {errorMessageProduct ? (
              <Typography color="error" textalign="center">
                {errorMessageProduct || 'Đang cập nhật giá'}
              </Typography>
            ) : (
              <div className={styles.rowPrice}>
                <div className={styles.priceInfo}>
                  <ProductDetailPrices
                    discountInfos={discountPriceInfo}
                    originPrice={originPrice}
                    tempPrice={displayPriceFormated}
                    isOnlyDiscountWithoutValue={isOnlyDiscountWithoutValue}
                  >
                    <Typography className={clsx(styles.price, 'flex items-baseline')}>
                      {product?.status !== 'OUT_OF_STOCK' && (
                        <SVGPrice key={product.sku} displayPriceFormated={displayPriceFormated} size="lg" fillPath="#0C884E" />
                      )}
                      {discountPriceInfo?.length && !isOnlyDiscountWithoutValue ? (
                        <Image src={PRODUCT_DETAIL_VOUCHER_ICON_PATH} alt="icon" width={20} height={20} />
                      ) : null}
                    </Typography>
                  </ProductDetailPrices>
                  {discountPercent ? (
                    <div style={{ display: 'flex', gap: 10 }}>
                      <span className={styles.originalPrice}>
                        {product?.status !== 'OUT_OF_STOCK' && (
                          <SVGPrice key={product.sku} displayPriceFormated={salePriceFormated || 0} size="sm" fillPath="#8D8D8D" line />
                        )}
                      </span>
                      <span className={styles.discountPercent}> -{discountPercent}%</span>
                    </div>
                  ) : null}
                </div>
              </div>
            )}
            <SectionRetailPrice price={highProfitRetailPrice} profit={highProfitRetailValue} />
            {product?.status !== 'OUT_OF_STOCK' && !errorMessageProduct && (
              <ProductDetailAlertPriceAfterApplyVoucher
                text={product?.isHighProfit ? flexibleWarning?.text?.highProfitText : flexibleWarning?.text?.defaultText}
                condition={condDisplayPriceAfterApplyVoucher()}
                isProductDetail
                style={flexibleWarning?.style}
              />
            )}

            <div className={styles.hightLightTag}>
              {medicineTypeLabels.length > 0 && (
                <div className={styles.medicineType}>
                  {medicineTypeLabels.map((info) => (
                    <ImageFallbackStatic
                      key={info.variant}
                      src={info.icon.src}
                      height={20}
                      width={Math.round((info.icon.width / info.icon.height) * 20)}
                      alt={info.label}
                    />
                  ))}
                </div>
              )}
              <TagComponent
                product={{
                  tags: product.tags,
                  statusData: product.statusData,
                  expiredDate: product.expiredDate,
                  isProductDetailPage: true,
                  isHangDiemStore: isHangDiem,
                  iconHangDiem,
                }}
                isProductCard={false}
                isSellerList={false}
                isPageDetail
                link={isHangDiem ? linkRedirect : link}
                isLinkTagDeal
              />
            </div>

            {product?.retailPriceApplyVoucher > 0 && <PriceAfterDiscount retailPriceApplyVoucher={product?.retailPriceApplyVoucher} />}

            {doseUnitName != '' && retailPricePerUnit > 0 ? (
              <div className={styles.referenceRetailPrice}>
                <AttachMoneyIcon sx={{ color: '#797979', border: '1px solid', borderRadius: '100%', fontSize: '14px' }} styles />
                Giá mua lẻ trên từng {doseUnitName?.toLowerCase()}
                <Typography>
                  <SVGPrice key={product?.sku} displayPriceFormated={formatCurrency(retailPricePerUnit)} fillPath="#0C884E" size="sm" />
                </Typography>
              </div>
            ) : null}

            {conditionRenderNextLevel() ? (
              <Typography className={styles.promoLevel}>
                <MoneyIcon />
                Bạn sẽ mua được giá{' '}
                <span className={styles.pricePromo}>
                  <SVGPrice key={product?.sku} displayPriceFormated={nextPrice} size="sm" fillPath="#0C884E" />
                </span>{' '}
                khi đạt cấp bậc <span className={styles.level}>{LEVEL_CUSTOMER[nextLevel]}</span>
              </Typography>
            ) : null}
            {infoGift.length > 0 && <PromotionPC handleOpen={handleOpen} listsPromo={vouchers} listPromoProduct={infoGift} />}

            <ComboList skus={product.skus} />

            {/* coupon list collection */}
            {loading.voucherCollectList ? (
              <VoucherCollectListSkeleton />
            ) : (
              <>
                {!errorMessageProduct && (
                  <SlideCoupon
                    coupons={listVoucherProduct}
                    sellerCode={sellerCode}
                    sku={sku}
                    skuName={name}
                    sellerName={fullNameSeller}
                    vendorInfo={vendorInfo}
                  />
                )}
              </>
            )}

            {/* BV-2271: có SP mua kèm thì gộp SPTT + SP mua kèm vào 1 block "Gợi ý cho bạn", không có thì giữ block SPTT cũ.
                quantityVariant quickOrder = tầng CartContext, cùng tầng với SPTT ở PDP. id product__replace để tour SPTT tìm thấy */}
            {!errorMessageProduct && !!product?.crossSell?.length ? (
              <>
                <SuggestProductBlock
                  id="product__replace"
                  flush
                  substitutes={product.skuReplaceLite}
                  crossSell={product.crossSell}
                  quantityVariant="quickOrder"
                  mainSKU={sku}
                  mainSKUProductId={productId?.toString()}
                  mainSKUSellerId={product?.sellerID}
                  mainType={product?.errorCode || 'NORMAL'}
                />
                {showSubstituteGuide && !!product?.skuReplaceLite?.length && <TourSubstituteSKU />}
              </>
            ) : (
              <ReplaceProduct
                productReplace={productReplace}
                isShowViewMore={isShowViewMore}
                slugCurrent={slug}
                showGuide={showSubstituteGuide}
                productParent={product}
              />
            )}

            {loading.sameProduct ? (
              <Skeleton variant="rect" width="100%" height={129} />
            ) : (
              productsSame?.length > 0 &&
              !configs?.['HIDE_SPECIFIED_BLOCKS_IN_PRODUCT_DETAIL_BY_SELLER']?.sellerCodes?.includes(product?.sellerCode) && (
                <AnotherSeller
                  key={`AnotherSeller-${slug}`}
                  productCompare={product}
                  products={productsSame}
                  title="Các nhà bán hàng khác cũng bán sản phẩm này"
                  ref={refTwo}
                  toggleOpenModal={toggleOpenModal}
                  sellerTypeNoViewMore={SellerTypeNoViewMore}
                />
              )
            )}

            {!configs?.['HIDE_SPECIFIED_BLOCKS_IN_PRODUCT_DETAIL_BY_SELLER']?.sellerCodes?.includes(product?.sellerCode) && (
              <BuyWithDeal products={productDeals} ref={refThree} link={link} />
            )}

            <div className={styles.groupInfoSeller}>
              <OtherInfoSeller
                key={`OtherInfoSeller-${slug}`}
                product={product}
                fullName={individualNonVatSellerName || sellerName}
                slug={sellerInfo?.slug}
                avatar={avatar}
                seller={{ ...seller, vendorSellerCode: vendorInfo?.sellerCode }}
                isStore={isStore}
                isInternal={isInternal}
                isDisplayStore={isDisplayStore}
                linkSeller={linkSeller}
                linkStore={linkStore}
                isVip={sellerInfo?.isVip}
              />
              {conditionRenderIntroduceHardCode() ? (
                <>
                  {product?.vendorInfo?.description && (
                    <div className={styles.commonContainer}>
                      <Typography className={styles.titleCommon}>Giới thiệu chung</Typography>
                      <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{
                          __html: product?.vendorInfo?.description || '',
                        }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  {conditionRenderIntroduce() ? (
                    <div className={styles.commonContainer}>
                      <Typography className={styles.titleCommon}>Giới thiệu chung</Typography>
                      <div
                        className={styles.content}
                        dangerouslySetInnerHTML={{
                          __html: product?.sellerInfo?.description || product?.vendorInfo?.description || '',
                        }}
                      />
                    </div>
                  ) : null}
                </>
              )}
            </div>
          </Grid>
        </Grid>
        <SectionInformation product={product} ref={refFour} />
        <QuestionAndAnswer
          user={user}
          targetCode={sku}
          priceFeedback={
            !errorMessageProduct && (
              <div className={styles.assessPrice}>
                <Typography className={styles.typographyRight}> Bạn thấy giá này?</Typography>
                <IconButtonCustom
                  icon={<ThumbUpOffAltIcon />}
                  isDisabled={!!feedback?.type || feedback?.disabledFeedbackPrice}
                  isHightLight={feedback?.type === LIKE_FEEDBACK_CODE}
                  onClick={handleLogical}
                  title="Hợp lí"
                  tooltipTitle={conditionRenderTitle(feedback?.type)}
                />
                <IconButtonCustom
                  icon={<ThumbDownOffAltIcon />}
                  isDisabled={!!feedback?.type || feedback?.disabledFeedbackPrice}
                  isHightLight={feedback?.type === DISLIKE_FEEDBACK_CODE}
                  onClick={toggleModalHighPrice}
                  title="Cao"
                  tooltipTitle={conditionRenderTitleFb(feedback?.type)}
                />
              </div>
            )
          }
        />

        {/* Recommendation blocks */}
        <ProductsRecommendation product={product} />
        <ProductsSameSeller product={product} sellerInfo={sellerInfo} />
        <ProductsSameIngredient product={product} />

        {isShowModalHighPrice && (
          <FeedbackPriceFormModal productId={productId} sku={sku} visible={isShowModalHighPrice} onClose={toggleModalHighPrice} />
        )}
      </Container>

      <ModalViewMore
        product={product}
        imagesProxy={imagesProxy}
        orderedCount={orderedCount}
        user={user}
        openModal={openModal}
        limitPerDay={limitPerDay}
        messageLimitOrder={messageLimitOrder}
        closeModal={closeModal}
        monthYear={monthYear}
        productType={productType}
        name={name}
        volume={volume}
        displayPriceFormated={displayPriceFormated}
        salePriceFormated={salePriceFormated}
        discountPercent={discountPercent}
        productsSame={productsSame}
        sellerInfo={sellerInfo}
        campaign={campaign}
        deal={deal}
      />

      <PromotionDetailModal
        className={styles.promoTionWrap}
        visible={showGiftModal}
        onClose={() => {
          setShowGiftModal(false);
        }}
        title="Khuyến mãi quà tặng"
        listsPromo={vouchers}
      />

      {stepState?.isFinish ? null : (
        <TourIntro
          steps={[
            {
              context: <>Hình ảnh sản phẩm, nút mua hàng được thay đổi vị trí để quý khách hàng có trải nghiệm mua sắm thuận tiện hơn!</>,
              position: 'right',
              name: 'addToCart',
              refCurrent: refOne,
              stylesArrow: { transform: 'rotate(90deg)', top: '10%', left: '-28px' },
            },
            {
              context: <>Quý khách có thể nhanh chóng tìm kiếm, so sánh giá bán của cùng một sản phẩm đến từ các nhà bán hàng khác nhau.</>,
              position: 'left',
              name: 'productsSame',
              refCurrent: refTwo,
              stylesArrow: { transform: 'rotate(-90deg)', top: '10%', right: '-28px' },
            },
            {
              context: (
                <>
                  Với mục <span className={styles.dealShock}>Mua Kèm Deal Sốc</span>, quý khách có thể xem các combo, ưu đãi của sản phẩm đang xem.
                </>
              ),
              position: 'left',
              name: 'productsDeal',
              refCurrent: refThree,
              stylesArrow: { transform: 'rotate(-90deg)', top: '10%', right: '-28px' },
            },
            {
              context: <>Thông tin sản phẩm giờ đây được sắp xếp lại giúp quý khách theo dõi thông tin một cách dễ dàng hơn.</>,
              position: 'top',
              name: 'infoProduct',
              refCurrent: refFour,
              stylesArrow: { transform: 'rotate(-90deg)', top: '10%', right: '-28px' },
            },
          ]}
          name="stepProductDetail"
          isReady={isReady}
          onFinish={onFinish}
        />
      )}

      <ModalTour
        open={open}
        handleCloseModal={handleClose}
        handleConfirmModal={handleConfirmModal}
        defaultSteps={defaultSteps}
        stepsFinish={stepState?.stepsFinish}
      />
    </div>
  );
}
